import { attributionUuid } from 'utils/mercury/partials';
import trackMercuryEvent from 'utils/mercury/trackMercuryEvent';

import { EmployeeCountOption } from '../schedule-demo-wizard';

export enum ScheduleDemoMercuryAction {
  EMPLOYEES_SIZE_SELECTED = 'employeesSizeSelected',
  MODAL_CLOSED = 'modalClosed',
  MODAL_OPENED = 'modalShown',
  START_TRIAL_MODAL_OPENED = 'startTrialModalOpened',
  START_TRIAL_SUCCESSFUL = 'startTrialSuccessful',
  VIDEO_DEMO_BUTTON_CLICKED = 'videoDemoButtonClicked',
  WEBINAR_REGISTERED = 'webinarRegistered',
  WEBINAR_REGISTRATION_ABANDONED = 'webinarRegistrationAbandoned',
  WEBINAR_REGISTRATION_ACCESSED_AFTER_CALENDLY_CALENDAR_BOOKING = 'webinarRegistrationAccessedAfterCalendlyCalendarBooking',
}

export type EmitScheduleDemoEventFormData = {
  formId: 'webinarRegistration' | 'hubspotBooking' | 'scheduleDemoTrialSignUp'
  insensitiveFields: Record<string, string | boolean | number | undefined>
  sensitiveFields: {
    email: string
    firstName: string
    lastName: string
    phoneNumber?: string
  }
}

export type EmitScheduleDemoEventProps = {
  action: ScheduleDemoMercuryAction,
  annotations?: Record<any, any>
  employeesSize: EmployeeCountOption | undefined,
  formData?: EmitScheduleDemoEventFormData
}

export default function emitScheduleDemoEvent(props: EmitScheduleDemoEventProps) {

  const { action } = props;

  const cookieId = attributionUuid();

  const scheduleDemoData = {
    action: action,
    annotations: props.annotations ? JSON.stringify(props.annotations) : null,
    cookieId,
    employeesSize: props.employeesSize ?? null,
    hostName: window.location.hostname,
    path: window.location.pathname,
  };

  trackMercuryEvent('marketing::scheduleDemoModal', scheduleDemoData);

  if (props.formData) {

    const formSubmissionData = {
      annotations: '',
      cookieId,
      email: props.formData.sensitiveFields.email,
      fields: JSON.stringify(props.formData.insensitiveFields),
      firstName: props.formData.sensitiveFields.firstName,
      formId: props.formData.formId,
      lastName: props.formData.sensitiveFields.lastName,
      origin: 'marketing',
      phoneNumber: props.formData.sensitiveFields.phoneNumber ?? '',
      queryParams: '',
      referralPage: window.location.pathname,
    };

    trackMercuryEvent('marketing::formSubmissions', formSubmissionData);

  }

}
